import React from 'react';
import { getLocalizedStrings } from '../utils_android/LocalizedStrings';
import moment from 'moment'
import 'moment/min/locales'
import { DateRange } from 'react-date-range';
import ruLocale from 'date-fns/locale/ru'
import { formateDate } from '../analyze_review/utils/DateHelper';
import { getOrderStatsParams, getDates, getFormattedDate } from '../utils_android/Utils';
import { getHttpParams, getRequestUrl } from '../analyze_review/utils/Utils';
import cross_icon from '../custom_icons/cross.svg'

import Loader from '../analyze_review/customViews/Loader';
import StatsChart from '../StatsChart';
import EmptyStats from '../empty_views/EmptyStats';
var colors = ['#2F80ED', '#1ED9C7', '#F2994A', '#EB5757', '#9B51E0', '#6FCF97', '#56CCF2', '#219653', '#4F4F4F', '#828282']
var strings = getLocalizedStrings()
class OrderInfoStats extends React.Component {
    constructor(props){
        super(props)
        const lastWeekDay = new Date(moment().subtract(6, "days"))
        const startTaskDate = new Date(this.props.isUniversal ? this.props.order.create_date : this.props.order.date_run)
        var selectionRange = {
            startDate: startTaskDate <= lastWeekDay ? lastWeekDay : startTaskDate,
            endDate: new Date(),
            key: 'selection',
            
        }
        this.state = {
            isShowDates : false,
            selectedRange : selectionRange,
            installsData : [],
            series : [],
            labels : [],
            isLoading : false
        }
    }
    componentDidMount(){
        this.getStats(this.state.selectedRange)
    }
    toogleDates = () => {
        this.setState({isShowDates : !this.state.isShowDates})
    }
    handleSelect = (ranges) => {
        if (ranges.selection.startDate != ranges.selection.endDate){
            this.setState({isShowDates : false})
            this.getStats(ranges.selection)
        }
        this.setState({selectedRange : ranges.selection})
    }
    getStats = (ranges) => {
        this.setState({installsData : [], isLoading : true})
        var params = getOrderStatsParams(ranges, this.props.order)

        fetch(getRequestUrl() + (this.props.isUniversal ? "getOrderStatisticYoutube" : "getOrderStatistic"), getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            var installsData = []
            var dateLabels = getDates(this.state.selectedRange.startDate, this.state.selectedRange.endDate)
            var colorIndex = 0
            for (var myOrder in responseData){
                var employers_dates = []
                if (responseData[myOrder].employers_dates) {
                    employers_dates = responseData[myOrder].employers_dates;
                } else if (responseData[myOrder].employers_dates_review) {
                    employers_dates = responseData[myOrder].employers_dates_review;
                }
                if (employers_dates.length > 0) {
                  var installs = [];
                  for (var j in dateLabels) {
                    var date = dateLabels[j];
                    for (var j in dateLabels) {
                        var date = dateLabels[j];
                        const foundDates = employers_dates.filter(currentDate => date == getFormattedDate(currentDate.date));
                          if (foundDates.length > 0) {
                            if (foundDates[0].count_installs){
                                installs.push(foundDates[0].count_installs)
                            } else if (foundDates[0].count_reviews){
                                installs.push(foundDates[0].count_reviews)
                            }
                          } else {
                            installs.push(0);
                          }
                    }
                  }
                  var searchReq = responseData[myOrder].search_request;
                  if (searchReq == undefined || searchReq == "") {
                    searchReq = this.props.isUniversal ? strings.installsCountStats : strings.withoutSearchReq
                  } 
                  var color = "black"
                  if (colors.length > colorIndex){
                      color = colors[colorIndex]
                  } else {
                      color = this.getRandomColor()
                  }
                  var dataObject = {
                      data : installs,
                      label : searchReq,
                      borderColor : color,
                      backgroundColor : color,
                      pointBorderColor : color,
                      pointRadius : 3,
                      borderWidth : 1,
                      pointBackgroundColor : "white",
                      fill: false,
                  }
                  colorIndex += 1
                  installsData.push(dataObject);
                }
              }
              
              this.setState({installsData : installsData, labels : dateLabels, isLoading : false})
          
        })
    }
    render(){
        return (
            <div style={{minHeight : '400px'}} className="relative">
                <div className="order_info_stats_title_cont">
                    <p className="order_info_stats_title">{this.props.isUniversal ? strings.univOrderTriesCount : strings.orderInfoInstallStats}</p>
                    <div className="order_info_stats_date_cont">
                        <p className="order_info_stats_filter">{strings.period}</p>
                        <p onClick={this.toogleDates} className="order_info_stats_filter order_info_stats_filter_date hover">{formateDate(this.state.selectedRange)}</p>
                        {this.state.isShowDates && <div onClick={this.toogleDates} className="tooltip_bg_dates"></div>}
                        {this.state.isShowDates && <div className="dates_info_cont"><DateRange locale={ruLocale} ranges={[this.state.selectedRange]} onChange={this.handleSelect}/></div>}
                    </div>
                </div>
                {this.state.isLoading ? <Loader /> :
                (this.state.installsData && this.state.installsData.length > 0) ? 
                    <div>
                        <div style={{marginLeft : '-16px', marginBottom : '16px', marginTop : '16px'}}>
                            <StatsChart installsData={this.state.installsData} labels={this.state.labels} series={this.state.series}/>
                        </div>
                        
                    </div> :
                <EmptyStats text1={strings.orderInfoInstallStatsEmpty} icon={cross_icon}/>}
                <div style={{marginBottom : '16px', opacity : 0}}>aa</div>
            </div>
            
        );         
    }
}
export default OrderInfoStats;
